const When_countrySelectChanges = require("./When_CountrySelect_changes");

/**
 * @param countrySelect {HTMLSelectElement}
 * @return {void}
 */
module.exports = function CountrySelect_init(countrySelect) {
    countrySelect.addEventListener("change", ev => {
        When_countrySelectChanges(ev.currentTarget)
    });
}